import { useState } from 'react';

const Settings = () => {
  const [apiKey, setApiKey] = useState('');
  const [refreshInterval, setRefreshInterval] = useState(30);
  const [alertsEnabled, setAlertsEnabled] = useState(true);

  const handleSave = () => {
    // Save settings to localStorage or API
    console.log('Settings saved');
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="mt-1 text-gray-600">Configure your PFVS Bridge Auditor preferences</p>
      </div>

      <div className="bg-white shadow sm:rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <div className="space-y-6">
            {/* API Configuration */}
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">API Configuration</h3>
              <div>
                <label htmlFor="api-key" className="block text-sm font-medium text-gray-700">
                  API Key
                </label>
                <input
                  type="password"
                  id="api-key"
                  value={apiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                  className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  placeholder="Enter your API key"
                />
              </div>
            </div>

            {/* Display Settings */}
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">Display Settings</h3>
              <div>
                <label htmlFor="refresh-interval" className="block text-sm font-medium text-gray-700">
                  Refresh Interval (seconds)
                </label>
                <input
                  type="number"
                  id="refresh-interval"
                  value={refreshInterval}
                  onChange={(e) => setRefreshInterval(Number(e.target.value))}
                  className="mt-1 block w-32 border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  min="5"
                  max="300"
                />
              </div>
            </div>

            {/* Alert Settings */}
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">Alert Settings</h3>
              <div className="flex items-center">
                <input
                  id="alerts-enabled"
                  type="checkbox"
                  checked={alertsEnabled}
                  onChange={(e) => setAlertsEnabled(e.target.checked)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor="alerts-enabled" className="ml-2 block text-sm text-gray-900">
                  Enable browser notifications for alerts
                </label>
              </div>
            </div>

            {/* Save Button */}
            <div className="pt-4">
              <button
                onClick={handleSave}
                className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Save Settings
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;